@import './ui-slide';

ui-slide {
  // TODO refactor: remove cms logic from core component
  ui-cms-anchor + .mgnlEditorBar.area.start {
    top: -54px;
  }
}
